import React, {forwardRef} from "react";
import {css, Theme} from "@emotion/react";

import {Container, Row} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    fluid?: boolean;
    className?: string;
    id?: string;
}

export const ColumnList = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    return (
        <Container className={props.className} fluid={props.fluid} id={props.id}>
            <Row ref={ref} as="ul" css={style}>
                {props.children}
            </Row>
        </Container>
    );
});

const style = (theme: Theme) => css`
    list-style-type: none;
    row-gap: ${theme.grid.md.gutter}px;
`;
import React, {forwardRef} from "react";
import {css, Theme} from "@emotion/react";

import {Container, Row} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    fluid?: boolean;
    className?: string;
    id?: string;
}

export const ColumnList = forwardRef<HTMLDivElement, IProps>((props, ref) => {
    return (
        <Container className={props.className} fluid={props.fluid} id={props.id}>
            <Row ref={ref} as="ul" css={style}>
                {props.children}
            </Row>
        </Container>
    );
});

const style = (theme: Theme) => css`
    list-style-type: none;
    row-gap: ${theme.grid.md.gutter}px;
`;
